<template>

    <div>
        <!-- Start About Area -->
        <section class="about-area ptb-80 mt-5">
            <div class="container">
                <div class="section-title">
                <h2>Services At A Glance</h2>
                <div class="bar"></div>
                <p style="max-width:80%">We offer you an opportunity to integrate modern - latest tools and technologies to your solutions as per the demand of the modern era. With our industrial experts, we deliver one-stop software development services as per our client’s requirements and industrial needs at affordable prices.</p>

            </div>

                <div class="row mt-5 pt-5">

                    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="about-content">
                            <div>    

                                    <h5>Softwares Development</h5>

                                    <p>
                                        OurSoftware developers are always looking for innovative ideas to push the boundaries to hand something new and unique to every customer using all the latest technologies available such as PHP, FLEX, ASP. We also understand that each and every client is different and the end product they want is different; We work according to the customer's needs and make something that is both innovative and productive.
                                    </p>

                                    <h5>Website Design & Development</h5>
                                    <p>
                                        Our design team will give you a perfect UI with clean and minimalist design that will give your brand the exposure you need for a successful business & as a full fledgedSoftware development company, our one-stop web development platform is one of the best in the market with all the latest PHP framework, Magneto, Html ,java with SEO you need to build a successful business platform. If your dream is to build a successful business platform on the web we are your one stop destination.
                                    </p>

                                    <h5>Mobile App Development</h5>
                                    <p>As your business grows, you need a responsive mobile app which can make your business dreams come true. Look no further than WB tech. Our Android and IOS developers are highly experienced in making a responsive and productive app which can make your dreams come true with using all the latest technologies such as AMP, unique API and a truck load of security and privacy protocols to make your dreams come true.</p>

                                    <h5>Search Engine Optimisation</h5>
                                    <p>
                                        SEO is the most important aspect of a growing business, it will help you to rank high on Google so that you reach your target audience and build a successful business around it. Our team has your years of experience on finding the perfect keywords that will help your business grow and rank one of the highest so you can make a successful business.
                                    </p>

                                    <h5>E-Commerce development</h5>
                                    <p>
                                        Making a perfect e-commerce website is a work of art. It includes all the necessary fields such as design, presentation, security and fluidity in the website that sets it apart from the rest.
                                        Our developers have been developing e-commerce websites for the last five years with innovative ideas for every other type of business; so that the customer can find the product they need and can buy them without hustle.
                                    </p>

                                    <h5>Graphics & UI design</h5>
                                    <p>
                                        Graphic design nowadays is a huge aspect of a growing business. A well thought UI I will give your brand perfect recognition on the global platform so that you reach the audience that you need for your growing business. Our team will give you the best designs that correlate with your ideas to give you a polished product.
                                    </p>

                                    <h5>Digital marketing and advertising</h5>
                                    <p>Digital marketing and advertising is a very important aspect to bring social media presence for your brand.We specialise in bringing the best advertisement solutions on all digital marketing platforms such as Facebook , Instagram and Twitter.</p>
                                    <h5>IT Consultancy</h5>
                                    <p>For a successful online presence you need proper planning and guidance on all the aspects of data management and technology. We will provide you proper guidance, consultancy & planning on all the aspects so that you can run your business without a worry.</p>
                                    
                                    <h5>Domain & Hosting</h5>
                                    
                                    <p>For a website & to showcase your brand you need web hosting and domain solutions. We here at WB tech provide one of the best web hosting and domain solutions with all the features you need at a very affordable price.</p>
                                    

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>


</template>

<script>
export default {
  name: "Privacy",
  components: {},
};
</script>